/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import {
  Redirect, useHistory, useLocation, useParams
} from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { _ } from '_locales';
import { connect } from 'react-redux';
import { quiz as quizActions } from '_actions';
import { eventTracker } from '_helpers';

import QuizOption from './components/QuizOption';
import { BodyText, Container, LinkButton } from './styles';
import events from '../Education/events';
import { Button } from '../Education/components';

const Body = styled.p`
  margin-bottom: 30px;
`;

const Title = styled.h3`
  margin-bottom: 10px;
`;

const OptionsContainer = styled.div`
  margin-bottom: 40px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  justify-content: space-between;
  align-items: left;
  width: 200px;
`;

const Quiz = ({
  setQuizStateAction,
  setQuizDataAction,
  quizData,
  quizState,
}) => {
  const { state } = useLocation();
  const { type, quizIndex } = useParams();
  const [didAnswer, setDidAnswer] = useState(false);
  const { replace, goBack, push } = useHistory();

  const quizType = {
    rf: {
      quiz: 'rfQuiz',
      data: 'recyclingFundamentals',
      landEvent: events.DZ_RF_QUIZ_LAND,
      optionSelectEvent: events.DZ_RF_QUIZ_SELECT_OPTION,
      backButtonEvent: events.DZ_RF_QUIZ_BACK_TAP,
    },
    lm: {
      quiz: 'lmQuiz',
      data: 'learningModules',
      landEvent: 'DZ_LM_QUIZ_LAND',
      optionSelectEvent: 'DZ_LM_QUIZ_SELECT_OPTION',
      backButtonEvent: 'DZ_LM_QUIZ_BACK_TAP',
    },
    mum: {
      quiz: 'mumQuiz',
      data: 'misundestoodMaterials',
      landEvent: events.DZ_MM_QUIZ_LAND,
      optionSelectEvent: events.DZ_MM_QUIZ_SELECT_OPTION,
      backButtonEvent: events.DZ_MM_QUIZ_BACK_TAP,
    },
  };

  const quizes = state?.isLearningModule
    ? (quizData[quizType[type].quiz]?.[state.lmIndex] || [])
    : (quizData[quizType[type].quiz] || []);

  useEffect(() => {
    const {
      id, campaign_id = null, activityId = null
    } = nav.current;
    const eventData = {};
    if (quizType[type].quiz === 'rfQuiz') {
      eventData.coachable_id = id;
      eventData.campaign_id = activityId;
    }
    if (quizType[type].quiz === 'lmQuiz') {
      eventData.coachable_id = id;
      eventData.lm_id = campaign_id;
      eventData.campaign_id = campaign_id;
    }
    if (quizType[type].quiz === 'mumQuiz') eventData.mat_id = id;
    eventTracker(quizType[type].landEvent, eventData);
  }, [type, quizIndex]);

  const nav = {
    current: quizes[Number(quizIndex)],
    next: quizes[Number(quizIndex) + 1],
    prev: quizes[Number(quizIndex) - 1],
  };
  const { title, options, question } = nav.current;

  const [quizOptions, setQuizOptions] = useState(options);
  useEffect(() => {
    const { options: theOptions } = nav.current;
    setQuizOptions(options);
    setDidAnswer(!!theOptions.find(({ selected }) => selected));
  }, [nav.current]);

  const proceed = () => {
    const {
      id,
      options: theOptions,
      correctOption,
      oidx: mat_oidx,
      activityId = null,
      campaign_id = null,
      ...rest
    } = nav.current;

    const { value: selectedOptionId } = quizOptions.find(
      ({ selected }) => selected
    );
    const didAnswerCorrect = selectedOptionId === correctOption;
    const updatedQuizes = [...quizes].map((item) => {
      if (item.id === id) {
        return {
          ...item,
          answered: true,
          options: item.options.map((option) => ({
            ...option,
            selected: option.value === selectedOptionId,
            nuetral: option.value !== correctOption && option.value !== selectedOptionId
          }))
        };
      }
      return item;
    });

    const eventData = {
      correct: didAnswerCorrect,
      selected_id: selectedOptionId,
      ...(quizType[type].quiz === 'rfQuiz'
        ? { coachable_id: id, campaign_id: activityId }
        : {}),
      ...(quizType[type].quiz === 'lmQuiz'
        ? { coachable_id: id, campaign_id }
        : {}),
      ...(quizType[type].quiz === 'mumQuiz' ? { mat_id: id, mat_oidx } : {}),
    };
    eventTracker(quizType[type].optionSelectEvent, eventData);
    setQuizDataAction({ ...quizData, [quizType[type].quiz]: updatedQuizes });
    setQuizStateAction({
      ...quizState,
      [quizType[type].quiz]: {
        ...quizState?.[quizType[type].quiz],
        [id]: {
          passed: didAnswerCorrect,
          failed: !didAnswerCorrect,
          answered: true,
          options: theOptions.map((option) => ({
            ...option,
            selected: option.value === selectedOptionId,
            nuetral: option.value !== correctOption && option.value !== selectedOptionId
          })),
          correctOption,
          ...rest,
        },
      },
    });

    if (nav.next) {
      return push(`/quiz/${type}/${nav.next.oidx}`, {
        lmIndex: state?.lmIndex,
        isLearningModule: state?.isLearningModule,
      });
    }

    return replace(`/quiz-feedback/${type}`, {
      lmIndex: state?.lmIndex,
      isLearningModule: state?.isLearningModule,
    });
  };

  const handleQuizSelection = (opt) => {
    const { correctOption } = nav.current;
    const newQuizOptions = quizOptions.map((qOption) => ({
      ...qOption,
      selected: qOption.value === opt,
      nuetral: qOption.value !== correctOption && qOption.value !== opt
    }));
    setQuizOptions(newQuizOptions);
    setDidAnswer(true);
  };

  const backHandler = () => {
    eventTracker(quizType[type].backButtonEvent, '');
    goBack();
  };

  if (!nav) return null;

  if (!quizes.length) {
    return <Redirect to="/" />;
  }

  return (
    <Container>
      {type === 'mum' ? (
        <>
          <Body>{title}</Body>
          <Title>{question}</Title>
        </>
      ) : null}
      {type === 'lm' ? (
        <>
          <Title>{title}</Title>
          <BodyText>
            <Body dangerouslySetInnerHTML={{ __html: question }} />
          </BodyText>
        </>
      ) : null}
      {type === 'rf' ? (
        <>
          <Title>{title}</Title>
          <BodyText>
            <Body dangerouslySetInnerHTML={{ __html: question }} />
          </BodyText>
        </>
      ) : null}
      <OptionsContainer>
        {quizOptions.map(
          ({
            id: optionsID, label, value, selected, nuetral
          }) => label && (
            <QuizOption
              key={`q-opt-${optionsID}`}
              value={value}
              selected={selected}
              nuetral={nuetral}
              isResult={false}
              onClick={handleQuizSelection}
            >
              {label}
            </QuizOption>
          )
        )}
      </OptionsContainer>

      <ButtonContainer>
        <Button
          style={{ flex: 1 }}
          className="btn outline royal"
          onClick={backHandler}
          aria-label={_('bulkPickup.back')}
        >
          {_('bulkPickup.back')}
        </Button>
        <Button
          style={{ flex: 1 }}
          disabled={!didAnswer}
          className="btn outline royal"
          onClick={proceed}
          aria-label={_('bulkPickup.next')}
        >
          {_('bulkPickup.next')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  quizData: state.quiz.quizData,
  quizState: state.quiz.quizState,
});

const mapDispatchToProps = (dispatch) => ({
  setQuizStateAction: (data) => dispatch(quizActions.setQuizState(data)),
  setQuizDataAction: (data) => dispatch(quizActions.setQuizData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Quiz);
